import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { createUserEdit } from '../users/UserEdit';
import { createUserList } from '../users/UserList';

const PlayerUsersList = createUserList({
    resource: 'admin/user-management/player-users',
    showRoleFilter: false,
    showImport: false,
    mode: 'player',
});

const PlayerUsersEdit = createUserEdit({
    resource: 'admin/user-management/player-users',
    cancelPath: '/admin/user-management/player-users',
    mode: 'player',
});

export default {
    list: PlayerUsersList,
    edit: PlayerUsersEdit,
    icon: SportsSoccerIcon,
    recordRepresentation: (record: any) => record.name || record.email,
};